// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"04c36a41","453":"555873fa"}[chunkId] + ".chunk.js";
};